import React from "react";
import { Instagram, Youtube, Facebook, Mail, Fish } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#0B1E36] text-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-20 md:py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="font-serif-display text-4xl leading-none tracking-tight text-white">
                CM
              </span>
              <Fish strokeWidth={1.5} className="w-6 h-6 text-[#C5A059]" />
            </div>
            <p className="mt-6 max-w-md text-white/70 leading-relaxed">
              Transformando vidas através da fé, do propósito e da ação.
              Conteúdo cristão profundo, impacto social e formação espiritual
              para a sua jornada.
            </p>

            <div className="mt-8 flex items-center gap-4">
              {[
                {
                  href: "https://www.instagram.com/ccarlosmedeiross/",
                  Icon: Instagram,
                  label: "Instagram",
                },
                {
                  href: "https://youtube.com/@conectadospelapalavra?si=4JJJcR_67zaRw14F",
                  Icon: Youtube,
                  label: "YouTube",
                },
                {
                  href: "https://www.facebook.com/profile.php?id=61588196565929",
                  Icon: Facebook,
                  label: "Facebook",
                },
                {
                  href: "mailto:carlosmedeiros@cemedeiros.com.br",
                  Icon: Mail,
                  label: "E-mail",
                },
              ].map(({ href, Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                  data-testid={`social-${label.toLowerCase()}`}
                  className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#C5A059] hover:text-[#C5A059] transition-all duration-300"
                  aria-label={label}
                >
                  <Icon size={16} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-6">
              Navegar
            </h4>
            <ul className="space-y-3 text-white/75">
              {[
                ["/sobre", "Sobre Carlos"],
                ["/instituto", "Instituto Garoto da Arena"],
                ["/livros", "E-books"],
                ["/palavra-de-hoje", "Devocional"],
                ["/sermoes", "Sermões"],
                ["/videos", "Vídeos"],
                ["/semana-de-oracao", "Oração"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    className="hover:text-[#C5A059] transition-colors duration-300"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-6">
              Contato
            </h4>
            <ul className="space-y-3 text-white/75">
              <li>
                <a
                  href="mailto:carlosmedeiros@cemedeiros.com.br"
                  className="hover:text-[#C5A059] transition-colors"
                >
                  carlosmedeiros@cemedeiros.com.br
                </a>
              </li>
              <li>
                <a
                  href="https://institutogaa.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#C5A059] transition-colors"
                >
                  Instituto Garoto da Arena
                </a>
              </li>
              <li>Igreja IECB Ágape</li>
            </ul>
            <p className="mt-8 text-xs text-white/40 uppercase tracking-[0.22em]">
              Fé · Propósito · Ação
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Carlos Medeiros. Todos os direitos reservados.
          </p>
          <p className="text-xs text-white/40 uppercase tracking-[0.22em]">
            “Aquietai-vos e sabei que eu sou Deus.” · Sl 46.10 (ARC)
          </p>
        </div>
      </div>
    </footer>
  );
}
